<template>
  <div class="e-container" ref="main"></div>
</template>

<script>
import echarts from 'echarts';
export default {
  props: {
    type: {
      type: String,
      default: 'primary'
    },
    option: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null
    };
  },
  watch: {
    option: {
      deep: true,
      handler(val) {
        if (this.chart) {
          this.chart.setOption(
            {
              ...val
            },
            true
          );
        }
      },
      immediate: true
    }
  },

  methods: {
    init(option) {
      this.chart = echarts.init(this.$refs.main);
      this.chart.setOption(option);
    }
  },
  mounted() {
    this.init(this.option);
  }
};
</script>

<style>
.e-container {
  height: 100%;
  width: 100%;
}
</style>
